import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import LoginPage from "@/pages/LoginPage";
import Dashboard from "@/pages/Dashboard";
import SalesDashboard from "@/pages/SalesDashboard";
import NewOrder from "@/pages/NewOrder";
import OrdersList from "@/pages/OrdersList";
import OrderDetail from "@/pages/OrderDetail";
import FabricsPage from "@/pages/FabricsPage";
import CollectionsPage from "@/pages/CollectionsPage";
import CustomersPage from "@/pages/CustomersPage";
import UsersPage from "@/pages/UsersPage";
import "@/App.css";

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for existing session
    const savedUser = localStorage.getItem("tinkah_user");
    const savedToken = localStorage.getItem("tinkah_token");
    if (savedUser && savedToken) {
      setUser(JSON.parse(savedUser));
    }
    setLoading(false);
  }, []);

  const handleLogin = (userData) => {
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem("tinkah_token");
    localStorage.removeItem("tinkah_user");
    setUser(null);
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-[#F5F5F0] flex items-center justify-center">
        <img src="/tinkah-logo.png" alt="TINKAH" className="h-12 animate-pulse" />
      </div>
    );
  }

  if (!user) {
    return (
      <>
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              fontFamily: "'Space Mono', monospace",
              borderRadius: 0,
              border: "1px solid #D6D6CF",
            },
          }}
        />
        <LoginPage onLogin={handleLogin} />
      </>
    );
  }

  const isSuperAdmin = user.role === "super_admin";

  return (
    <BrowserRouter>
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            fontFamily: "'Space Mono', monospace",
            borderRadius: 0,
            border: "1px solid #D6D6CF",
          },
        }}
      />
      <Layout user={user} onLogout={handleLogout}>
        <Routes>
          {/* Dashboard - Different for each role */}
          <Route path="/" element={isSuperAdmin ? <Dashboard /> : <SalesDashboard />} />
          
          {/* Orders - Both roles */}
          <Route path="/orders/new" element={<NewOrder user={user} />} />
          <Route path="/orders/:id/edit" element={<NewOrder user={user} />} />
          <Route path="/orders" element={<OrdersList user={user} />} />
          <Route path="/orders/:id" element={<OrderDetail user={user} />} />
          
          {/* Catalog - Both roles */}
          <Route path="/fabrics" element={<FabricsPage user={user} />} />
          <Route path="/collections" element={<CollectionsPage user={user} />} />
          <Route path="/customers" element={<CustomersPage user={user} />} />
          
          {/* Admin only */}
          {isSuperAdmin && <Route path="/users" element={<UsersPage />} />}
          
          {/* Catch all */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;

